import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from '../AppContext';

/**
 * AdminRoute bảo vệ route /admin chỉ cho admin truy cập.
 * Nếu chưa đăng nhập admin, sẽ chuyển hướng về /adminLogin.
 */
const AdminRoute = ({ children }) => {
  const { isAdminLoggedIn } = useContext(AppContext);

  if (!isAdminLoggedIn) {
    return <Navigate to="/adminLogin" replace />;
  }

  return children;
};

export default AdminRoute;
